import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Modal,
  Button,
  TextField,
  IconButton,
  Typography,
  Stack,
} from "@mui/material";
import { styled } from "@mui/system";
import axios from "axios";
import CloseIcon from "@mui/icons-material/Close";

// Styled modal component
const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

// Styling for the modal content
const ModalContent = styled("div")`
  background-color: white;
  border: 2px solid #000;
  padding: 20px;
  width: 400px;
  position: relative;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

// Close button styling
const CloseButton = styled(IconButton)`
  position: absolute;
  top: 10px;
  right: 10px;
`;

const LoginScreen = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  // const [token, setToken] = useState(localStorage.getItem('authToken'));
  const navigate = useNavigate();

  // Login handler
  const loginHandler = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        {
          email,
          password,
        }
      );

      // Save token to both state and localStorage

      localStorage.setItem("authToken", data.token);

      // Redirect after successful login
      setTimeout(() => {
        navigate("/");
      }, 1800);
    } catch (error) {
      setError(error.response?.data?.error || "An error occurred");
      setTimeout(() => {
        setError("");
      }, 6000);
    }
  };

  return (
    <StyledModal
      open={true}
      onClose={onClose}
      aria-labelledby="login-modal-title"
      aria-describedby="login-modal-description"
    >
      <ModalContent>
        <CloseButton onClick={onClose} color="inherit">
          <CloseIcon />
        </CloseButton>
        <Typography variant="h5" gutterBottom>
          Login
        </Typography>
        {error && <Typography color="error">{error}</Typography>}
        <Stack spacing={2} component="form" onSubmit={loginHandler}>
          <TextField
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button variant="contained" color="primary" type="submit" fullWidth>
            Login
          </Button>
        </Stack>
      </ModalContent>
    </StyledModal>
  );
};

export default LoginScreen;
